export const formatFareName = (fareName) => {
    if (!fareName)
        return fareName;
    return fareName
        .toLowerCase()
        .split(" ")
        .map((word) => (word ? word[0].toUpperCase() + word.slice(1) : ""))
        .join(" ");
};
